import { Component, effect, inject, input } from '@angular/core';
import { DataSeries } from 'src/app/models/classes/data-series.class';
import { KeyValuePair } from 'src/app/models/classes/key-value-pair.class';
import { CurrencyFormatPipe } from 'src/app/pipes/currency-format.pipe';
import { GROSVENOR_BLUE, WHITE } from '@gcm/gcm-ui-angular';
import { HighchartsService } from 'src/app/services/highcharts-service.service';
import { BaseWidgetComponent } from 'src/app/shared/base-widget/base-widget.component';
import { GcmChartComponent } from 'src/app/shared/gcm-chart/gcm-chart.component';
import { InfoIconComponent } from 'src/app/shared/info-icon/info-icon.component';

@Component({
    selector: 'app-sectors-widget',
    imports: [BaseWidgetComponent, InfoIconComponent, GcmChartComponent],
    templateUrl: './sectors-widget.component.html'
})
export class SectorsWidgetComponent {
  private highchartsService = inject(HighchartsService);
  private currencyFormat = inject(CurrencyFormatPipe);

  readonly widgets = input<Record<string, KeyValuePair<string | number, number>[]>>();
  readonly currency = input<string>();
  chartStyle = { width: '99%', display: 'flex' };
  sectorByRemainingMarketValue!: DataSeries;
  sectorByRemainingMarketValueChartOptions = {};

  private readonly rebuildChart = effect(() => {
    const widgets = this.widgets();
    if (widgets) {
      this.sectorByRemainingMarketValue = this.highchartsService.buildDataSeries(widgets['remainingValueBySector']?.slice(0, 10), 'Remaining Market Value');
      if (widgets['remainingValueBySector'] && widgets['remainingValueBySector'].length > 0) {
        const remainingValueForSectorSum = widgets['remainingValueBySector'].map(a => a.value).reduce((total, val) => total + val, 0);
        this.sectorByRemainingMarketValueChartOptions = this.buildSectorByRemainingMarketValueChartOptions(remainingValueForSectorSum);
      }
    }
  });

  buildSectorByRemainingMarketValueChartOptions(sum: number) {
    const currencyFormat = this.currencyFormat;
    const currency = this.currency();
    if (sum <= 0) {
      this.sectorByRemainingMarketValue.error = this.highchartsService.noResultsText;
      return {};
    }

    return {
      chart: {
        height: 360
      },
      plotOptions: {
        bar: {
          pointWidth: 34
        },
        series: {
          dataLabels: {
            formatter: function (this: Highcharts.Point) {
              const valToShow = ((Math.abs(this.y as number) / Number(sum)) * 100).toFixed(1) + '%';
              return valToShow;
            }
          }
        }
      },
      tooltip: {
        formatter: function (this: Highcharts.Point) {
          const valToShow = currencyFormat.transform(this.y, currency);
          const data = `${this.series.name} <br/>` + valToShow + ` <br/><hr class="mt-2 mb-2 mr-0 ml-0" style="background-color: ${WHITE}">`
          const footer = `<div>${this.key}</div>`
          return data + footer
        }
      },
      series: [{
        color: GROSVENOR_BLUE
      }]
    }
  }
}
